import { News } from '../types';

/**
 * Helper functions to work with news data from the API
 */

export const getNewsImage = (news: News): string => {
  return news.imagemUrl || '/img/news/default-news.jpg';
};

export const getNewsTitle = (news: News): string => {
  return news.titulo;
};

export const getNewsSubtitle = (news: News): string => {
  return news.subtitulo || '';
};

export const getNewsContent = (news: News): string => {
  return news.texto;
};

export const getNewsDate = (news: News): string => {
  return news.dataNoticia;
};

export const getNewsSource = (news: News): string => {
  return news.fonte || 'Agricampanha';
};

export const getNewsCategoryName = (news: News): string => {
  return news.categoria?.nome || 'Sem categoria';
};

export const formatNewsDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
};

export const formatNewsDateShort = (dateString: string): string => {
  const date = new Date(dateString);
  const formatted = date.toLocaleDateString('pt-BR', {
    month: 'long',
    year: 'numeric',
  });
  // Capitaliza apenas a primeira letra (ex: "outubro de 2025" → "Outubro de 2025")
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};

export const getNewsExcerpt = (news: News, maxLength: number = 150): string => {
  const text = news.texto;
  if (text.length <= maxLength) {
    return text;
  }
  return text.substring(0, maxLength).trim() + '...';
};
